import { useEffect, useRef, useState } from 'react';
import BTDropin, { Dropin } from 'braintree-web-drop-in';

interface UseBraintreeArgs {
  containerId: string,
  token: string,
  locale: string
}

interface UseBraintreeProps {
  btInstance?: Dropin;
  error?: object,
  isBraintreeReady: boolean,
  isPaymentRequestable: boolean
}

const useBraintree: (args: UseBraintreeArgs) => UseBraintreeProps = ({ containerId, token, locale }) => {
  const braintreeRef = useRef<Dropin>();
  const tokenRef = useRef<string>(token);
  const [isBraintreeReady, setIsBraintreeReady] = useState<boolean>(false);
  const [isPaymentRequestable, setIsPaymentMethodRequestable] = useState<boolean>(true);
  const [error, isError] = useState<object>();

  const callback: (
    error: object | null,
    dropinInstance: Dropin | undefined
  ) => void = (error, dropinInstance) => {
    if (error) {
      // console.log('error: ', error);
      // Handle errors in requesting payment method
      return isError(error)
    }

    braintreeRef.current = dropinInstance;
    setIsBraintreeReady(true);
  };

  /**
   * removes submit button disable when BT UI form is completed
   */
  braintreeRef.current?.on('paymentMethodRequestable', () =>
    setIsPaymentMethodRequestable(false)
  );

  /**
   * disabled submit button if payment method isn't available
   */
  braintreeRef.current?.on('noPaymentMethodRequestable', () =>
    setIsPaymentMethodRequestable(false)
  );

  useEffect(() => {
    // initialise Braintree
    tokenRef.current = token
    if (!braintreeRef.current && token) {
      BTDropin.create(
        {
          authorization: tokenRef.current,
          container: containerId,
          paypal: {
            flow: 'vault'
          },
          locale: locale
        },
        callback
      );
    }
  }, [containerId, token, locale]);

  return { btInstance: braintreeRef.current, error, isBraintreeReady, isPaymentRequestable }
}

export default useBraintree